export default "__VITE_ASSET__CBlBi9a$__"